import lodash from "lodash";
import { useSelector } from "react-redux";
import { bailiffDialogPreviewSelector } from "store/bailiff/bailiff/dialog/bailiff_dialog.selector";
import { bailiffJobAllSelector } from "store/bailiff/bailiff/job/bailiff_job.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
export const useJobRefine = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const data = useSelector(bailiffJobAllSelector);
  const extracting =
    data?.filter((d) => d?.status === "extracting")?.length || 0;
  const sorted = lodash.orderBy(data, "createAt", "desc") || [];
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { data: sorted, extracting };
};

export const useJobPreview = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const data = useSelector(bailiffDialogPreviewSelector);
  const sentences = data?.map((d) => d?.sentences || []);
  const flatten = lodash.flatten(sentences)?.slice(0, 3);

  console.log({ flatten });

  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { data, sentences: flatten };
};
